import React, {Component} from 'react';
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import currencyFormat from "../../helper/currencyFormat";
import withAuth from "../../hoc/withAuth";
import {offerApiServices} from "../../services/offer/OfferApiService";
import {offerGcpApiService} from "../../services/offer/OfferGcpApiService";
import {Tooltip, Button, Modal, Table, DatePicker, Form, Tag, Select, Row, Col, Dropdown, Menu, Divider, Switch, Input, message, Spin, Checkbox} from 'antd';
import {CheckCircleTwoTone, CopyOutlined, ExclamationCircleOutlined, ExportOutlined, FlagOutlined, FormOutlined, NotificationOutlined, PullRequestOutlined, SaveOutlined, ScanOutlined, ScheduleOutlined, SearchOutlined, WarningOutlined} from "@ant-design/icons";
import {ForceClosingStates} from "./types/ForceClosingTypes";
import moment from "moment";
import AreaGroupCitySelect from "../../components/area/AreaGroupCitySelect";
import DetailOffer from "../../components/offer/DetailOffer";
import Cookies from "universal-cookie";
import {stockApiService} from "../../services/otodis/StockApiService";
import DetailOrder from "../../components/order/DetailOrder";
import {idealChatServices} from "../../services/ideal/IdealChatService";
import {fulfillmentService} from "../../services/otodisApi/FulfillmentService";
import {shippingCostService} from "../../services/otodisApi/ShippingCostService";
import {catalogAreaServices} from "../../services/catalog/CatalogAreaService";
import {dealerApiService} from "../../services/otodis/DealerApiService";

const checkIdeal = true;

export interface ForceClosingProps {
}

class ForceClosing extends Component<ForceClosingProps & any, ForceClosingStates> {
    private readonly initState!: ForceClosingStates;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString());
    private token = new Cookies().get('_t');
    private tableStockUnitColumn: any = [
        {
            title: 'Kode Stock',
            dataIndex: 'stock_unit_code',
            width: 75,
            render: ((value: string) => {
                return <span style={{fontSize: '80%'}}>{`${value.toUpperCase()}`}</span>
            })
        },
        {
            title: 'Variant',
            dataIndex: 'vehicle_variant_name',
            width: 70,
            render: ((value: string, row: any) => {
                return <span style={{fontSize: '85%'}}>{row.vehicle_variant_code}<br/>{value}</span>
            })
        },
        {
            title: 'Warna',
            dataIndex: 'vehicle_color_name',
            width: 60,
            render: ((value: string, row: any) => {
                return <span style={{fontSize: '85%'}}>{row.vehicle_color_code}<br/>{value}</span>
            })
        },
        {
            title: 'NoMesin - NoRangka',
            dataIndex: 'vehicle_chassis_number',
            width: 80,
            render: ((value: string, row: any) => {
                return <span style={{fontSize: '85%'}}>{row.vehicle_engine_number}<br/>{value}</span>
            })
        },
        {
            title: 'Gudang',
            dataIndex: 'warehouse_name',
            width: 120,
            render: ((value: string) => {
                return <span style={{fontSize: '85%'}}>{value}</span>
            })
        },
        {
            title: 'Usia',
            dataIndex: 'stock_age_day',
            width: 80,
            render: ((value: string) => {
                return <span style={{fontSize: '85%'}}>{value}</span>
            })
        },
    ];
    private tableColumn: any = [
        {
            title: 'Kode Offer',
            dataIndex: 'transaction_code',
            width: 170,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span style={!row.credit_different_po_data ? {display: 'none'} : {}}>
                            <Tooltip title="Data PO berbeda dengan data offer" color={'red'}>
                                <WarningOutlined className={'small-avatar-danger'}/>
                                &nbsp;
                            </Tooltip>
                        </span>

                        <span style={(!row?.color_code || !row?.variant_code) ? {} : {display: 'none'}}>
                            <span style={row.additionalOrderPolicy ? {display: 'none'} : {}}>
                                <Tooltip title={`Data Offer Tidak Lengkap`} color={'orange'}>
                                    <ExclamationCircleOutlined className={'small-avatar-danger'}/> &nbsp;
                                </Tooltip>
                            </span>
                        </span>

                        <span style={(row?.qc_status) ? {} : {display: 'none'}}>
                            <Tooltip title={`Sudah dilakukan QC`} color={'green'}>
                                <CheckCircleTwoTone twoToneColor="#52c41a"/> &nbsp;
                            </Tooltip>
                        </span>

                        <span className={`font-90-link`} onClick={event => this.showOfferDetail(row)}>{value}</span>
                        &nbsp; &nbsp;
                        <Tooltip title="Click untuk copy kode offer" color={'cyan'}>
                            <CopyOutlined className={'small-avatar-link'} onClick={event => this.copyToClipboard(value)}/>
                        </Tooltip>
                        <span style={!row.order_code ? {display: 'none'} : {fontSize: '60%'}}>
                            <br/>
                            <span style={{cursor: "pointer"}} onClick={event => this.showDetailOrder(row.order_code)}>{row.order_code}</span>
                        </span>

                        <div style={(this.state.filterOfferStatus?.toLowerCase() === 'open' && this.state.filterCityGroupCode) ? {} : {display: 'none'}}>
                            <span style={{fontSize: "80%"}}>available: {row?.additional_stock ?? "-"} | payment: {currencyFormat(row?.additional_paid) ?? "-"} </span>
                            <span style={row.additionalOrderPolicy ? {display: 'none'} : {}}>
                                <Tooltip title={`Minimum Kebijakan Order ${currencyFormat(row?.additionalOrderPolicyMinimumPaid)}`} color={'orange'}>
                                    <WarningOutlined className={'small-avatar-danger'}/>
                                </Tooltip>
                            </span>
                        </div>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Metode',
            dataIndex: 'purchase_method',
            width: 75,
            render: ((value: string, row: any) => {
                return (value === 'cash') ? <Tag color="error">Tunai</Tag> : <Tag color="success">Kredit</Tag>
            })
        },
        {
            title: 'Status',
            dataIndex: 'offer_status',
            width: 75,
            render: ((value: string, row: any) => {
                let status: any = "-";
                if (value.toUpperCase() === 'OPEN') {
                    status = <Tag color="processing">Open</Tag>;
                } else if (value.toUpperCase() === 'CANCEL') {
                    status = <Tag color="error">Cancel {(row?.cancel_admin_id === 'SYSTEM') ? "SYSTEM" : ""}</Tag>;
                } else if (value.toUpperCase() === 'ORDER') {
                    status = <Tag color="success">Order</Tag>;
                }
                return status;
            })
        },
        {
            title: 'Area',
            dataIndex: 'area',
            width: 90,
            render: ((value: string, row: any) => {
                return <span style={{fontSize: '85%'}} className={`font-90`}>{`${value.toUpperCase()}`}</span>
            })
        },
        {
            title: 'Sumber',
            dataIndex: 'source',
            width: 140,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span className={`font-90-bold`}>{`${value}`}</span><br/>
                        <span style={row?.purchase_method === 'cash' ? {display: 'none'} : {}}><span className={`font-70`}>{`${row?.finco_code?.toUpperCase()}`}</span> - <span className={`font-70`}>{`${row?.po_code}`}</span></span>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Tgl Transaksi',
            dataIndex: 'transaction_time',
            width: 150,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span style={{fontSize: "85%"}} className={`font-90`}>{`${value.substring(0, 10)}`}</span><br/>
                        <span style={!row?.survey_created_time ? {display: 'none'} : {}}>
                            <Tooltip title="Tanggal Form Kredit Dibuat" color={'cyan'}>
                                <ExportOutlined style={{fontSize: "75%", cursor: "help"}}/>
                            </Tooltip>
                            <span style={{fontSize: "70%", paddingLeft: 3}} className={`font-90`}>{`${row?.survey_created_time?.substring(0, 10)}`}</span>
                        </span> &nbsp;
                        <span style={(!row?.po_time || row?.purchase_method === 'cash') ? {display: 'none'} : {}}>
                            <Tooltip title="Tanggal PO" color={'cyan'}>
                                <FormOutlined style={{fontSize: "75%", cursor: "help"}}/>
                            </Tooltip>
                            <span style={{fontSize: "70%", paddingLeft: 3}} className={`font-90`}>{`${row?.po_time?.substring(0, 10)}`}</span>
                        </span>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Agen',
            dataIndex: 'agent_code',
            width: 80,
            render: ((value: string, row: any) => {
                return <span className={`font-90`}>{`${value}`}</span>
            })
        },
        {
            title: 'Variant',
            dataIndex: 'variant_name',
            width: 150,
            render: ((value: string, row: any) => {
                return <span style={{fontSize: '85%'}}>{row.variant_code}<br/>{value}</span>
            })
        },
        {
            title: 'Warna',
            dataIndex: 'color_name',
            width: 150,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span className={`font-90`}>{row.color_code} - {value}</span><br/>
                        <span style={!row?.color_alternative ? {display: 'none'} : {fontSize: '75%'}}>
                            <Tooltip title="Warna Alternatif" color={'cyan'}>
                                <NotificationOutlined style={{cursor: "help"}}/> {row?.color_alternative?.name}
                            </Tooltip>
                        </span>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Nama Pemilik',
            dataIndex: 'owner_full_name',
            width: 100,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span className={`font-90`}>{`${value}`}</span><br/>
                        <span className={`font-70`}>{`${row?.owner_id_card_number}`}</span>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Action',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: ((row: any, obj: any, index: number) => {
                const menu = (
                    <Menu>
                        <Menu.Item key={1}>
                            <span onClick={event => this.showOfferDetail(row)} style={{cursor: "pointer"}}> <SearchOutlined/> Lihat Detail</span>
                        </Menu.Item>
                        <Menu.Item key={2} style={row.order_code ? {display: 'none'} : {}}>
                            <span onClick={event => this.createOrder(row, index)} style={{cursor: "pointer"}}> <PullRequestOutlined/> Closing Otomatis</span>
                        </Menu.Item>
                        <Menu.Item key={3} style={row.order_code ? {display: 'none'} : {}}>
                            <span onClick={event => this.createClosingUnitOrder(row, index)} style={{cursor: "pointer"}}> <ScanOutlined/> Closing Cari Unit</span>
                        </Menu.Item>
                    </Menu>
                );

                return <React.Fragment>
                    <span className={`font-90`}>
                        <Dropdown overlay={menu} placement="bottomLeft" arrow>
                          <Button size={"small"} type={"primary"}> <ScheduleOutlined/> Aksi</Button>
                        </Dropdown>
                    </span>
                </React.Fragment>
            })
        },

    ];

    constructor(props: ForceClosingProps & any | any) {
        super(props);
        const dealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());
        const dealerOption = [];
        for (const item of dealer) {
            dealerOption.push({
                value: item.DealerCode,
                name: item.DealerName
            });
        }

        this.initState = {
            dealerOption: dealerOption,

            processing: false,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            processingFetchTableData: false,
            dataOffer: [],
            pageSize: 100,
            showModalDetailStock: false,
            filterStartDate: moment().format('YYYY-MM-DD'),
            filterEndDate: moment().format('YYYY-MM-DD'),
            // filterStartDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
            // filterEndDate: moment().clone().endOf('month').format('YYYY-MM-DD'),
            filterOfferStatus: "open",
            filterPurchaseMethod: "",
            filterCityGroupCode: "",
            filterCityGroupName: "",
            filterCityGroupStockCode: "",
            chosenOfferCode: "",
            chosenOfferRow: {},
            chosenOfferYear: new Date().getFullYear(),
            chosenOfferData: {},
            createOrderOfferCode: "",
            createOrderOfferModal: false,
            createOrderOfferProcessing: false,
            chosenCloseUnitSearchType: true,
            chosenCloseUnitOfferCode: "",
            chosenCloseUnitVehicleNumber: "",
            chosenCloseUnitOfferData: {},
            chosenCloseUnitStockData: [],
            chosenCloseUnitStockCode: "",
            chosenCloseUnitYear: new Date().getFullYear(),
            chosenCloseUnitVehicle: {},
            chosenCloseUnitModal: false,
            chosenCloseUnitFetching: false,
            chosenCloseUnitProcessing: false,
            chosenCloseUnitDealerCode: null,
            chosenCloseUnitSelectedRowsKey: [],
            chosenCloseUnitSelectedRowsData: [],
            detailOrderCode: "",
            detailOrderModal: false,
            fetchIdealProcess: false,
            dataConfig: {},
            processingFetchConfig: true,
            fulfillmentProcess: false,
            fulfillmentModal: false,
            shipmentCostFetch: true,
            shipmentCostShow: false,
            shipmentCostData: {success: false},
            fetchCatalogueProcess: false,
            otrCatalogueDifferent: false,
            otrCatalogue: 0,
            otrCatalogueShow: false,
            dealershipPickUp: false,
            dealerCityGroupData: {},
        }
        this.state = {...this.initState}
    }

    fetchConfig = async () => {
        await this.promisedSetState({
            processingFetchConfig: true,
            dataConfig: this.state.dataConfig
        });

        fulfillmentService.getConfigFulfillment()
            .then(async value => {
                await this.promisedSetState({
                    processingFetchConfig: false,
                    dataConfig: value.data.data
                });
            }).catch(async reason => {
            await this.promisedSetState({
                processingFetchConfig: false,
                dataConfig: this.state.dataConfig
            });
        })
    }

    showDetailOrder = async (code: any) => {
        this.setState({
            detailOrderCode: code,
            detailOrderModal: true,
        })
    }

    closeModalDetailOrder = async (code: any) => {
        this.setState({
            detailOrderCode: "",
            detailOrderModal: false,
        })
    }

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            dataOffer: [],
            dealerCode: data.value,
        });
    }

    copyToClipboard = async (data: any) => {
        await navigator.clipboard.writeText(data);
        message.info('Kode Berhasil di Copy');
    }

    closeModalDetailStock = (data: any) => {
        this.setState({
            showModalDetailStock: false,
        });
    }

    showOfferDetail = async (data: any) => {
        await this.promisedSetState({
            chosenOfferCode: data.transaction_code,
            chosenOfferData: data,
            showModalDetailStock: true,
        });
    }

    sortOpenOffer = async (data: any) => {
        const finalData: any = [];
        const warnedOrderPolicy = [];
        for (const item of data) {
            if (item?.additional_stock > 0 && item?.additional_payment) {
                if (item?.additionalOrderPolicy) {
                    finalData.push(item);
                } else {
                    warnedOrderPolicy.push(item);
                }
            }
        }

        // sorting by paid amount
        finalData.sort((a: any, b: any) => {
            return b.additional_paid - a.additional_paid;
        });

        await this.promisedSetState({
            // dataOffer: finalData.concat(warnedOrderPolicy),
            dataOffer: finalData,
            processingFetchTableData: false,
        });
    }

    closingFulfillment = async () => {
        this.setState({
            fulfillmentProcess: false,
            fulfillmentModal: true,
        })
    }

    closeFulfillmentModal = async () => {
        this.setState({
            fulfillmentProcess: false,
            fulfillmentModal: false,
        });
    }

    fetchCatalogueVariant = async () => {
        await this.promisedSetState({
            fetchCatalogueProcess: true,
            otrCatalogueDifferent: false,
            otrCatalogueShow: false,
            otrCatalogue: 0,
        });

        if (!this.state.dealerCityGroupData[this.state.chosenCloseUnitDealerCode]?.city_group) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'dealer yang dipilih belum disetup cityGroup'
            });
            return;
        }

        try {
            await catalogAreaServices.getCatalogVariant({
                areaCode: this.state.dealerCityGroupData[this.state.chosenCloseUnitDealerCode]?.city_group,
                variantCode: this.state.chosenCloseUnitOfferData.variant_code,
            }).then(async dataVariantHome => {
                let tempCatalogueDifferent = (this.state.chosenCloseUnitOfferData.otr_price !== dataVariantHome?.data?.meta?.Price);
                await this.promisedSetState({
                    fetchCatalogueProcess: false,
                    otrCatalogueDifferent: tempCatalogueDifferent,
                    otrCatalogueShow: true,
                    otrCatalogue: dataVariantHome?.data?.meta?.Price,
                });
            });
        } catch (e) {
            await this.promisedSetState({
                fetchCatalogueProcess: false,
                otrCatalogueDifferent: false,
                otrCatalogueShow: true,
                otrCatalogue: 0,
            });
        }
    }

    setFulfillmentClosing = async () => {
        this.setState({
            fulfillmentProcess: true,
        });

        const input = {
            company: "amarta",
            last_update_admin: this.user,
            update_fulfillment_update_time: true
        }

        if (this.state?.dataConfig?.auto_closing_status) {
            try {
                await offerGcpApiService.autoClosing(
                    input
                ).then(successData => {
                    console.log("auto closing success");
                    Modal.success({
                        title: 'Proses Sukses',
                        content: 'Pemenuhan berhasil dibuat'
                    });
                    this.setState({
                        fulfillmentProcess: false,
                        fulfillmentModal: false,
                        dataOffer: []
                    });
                });
            } catch (e) {
                Modal.error({
                    title: 'Proses Auto Closing Gagal, Segera hubungi sysadmin',
                    content: 'Server Menolak Inputan Anda :' + e + 'Segera hubungi sysadmin'
                });
                return;
            }
        }

        /* // AUTO FILLFILLMENT SUDAH DIPINDAH KE BACKEND AUTO-CLOSING
        try {
            await fulfillmentService.closingFulfillment(
                input
            ).then(successData => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'Pemenuhan berhasil dibuat'
                });
                this.fetchConfig();

                this.setState({
                    fulfillmentProcess: false,
                    fulfillmentModal: false,
                    dataOffer: []
                });
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            await this.promisedSetState({
                fulfillmentProcess: false,
            });
        }
        */
    }

    fetchOffer = async () => {
        const diffDays = moment(this.state.filterEndDate).diff(moment(this.state.filterStartDate), 'days');
        if (diffDays > 14) {
            message.open({
                type: 'error',
                content: <span>Pencarian Data hanya dapat dilakukan dalam range 14 hari. <br/><br/> jika ingin mencari data januari 2021, tglAwal: 2021-01-01 dan tglAkhir: 2021-01-14 </span>,
                duration: 4,
            });
            return;
        }

        if (this.state.dataConfig?.event_status) {
            await this.fetchConfig();
        }

        if (this.state.filterOfferStatus?.toLowerCase() === 'open' && !this.state.filterCityGroupCode) {
            Modal.error({
                title: 'error',
                content: 'Untuk kondisi Open pada offer to order, diwajibkan memilih Area',
            });
            return;
        }

        if (this.state.filterOfferStatus?.toLowerCase() === 'open' && !this.state.filterCityGroupStockCode) {
            Modal.error({
                title: 'error',
                content: 'Untuk kondisi Open pada offer to order, diwajibkan memilih Stock Area',
            });
            return;
        }

        await this.promisedSetState({
            dataOffer: [],
            processingFetchTableData: true,
        });

        await offerApiServices.setToken(this.token);
        await offerApiServices.getOffer({
            area: this.state.filterCityGroupCode,
            areaStock: this.state.filterCityGroupStockCode,
            status: this.state.filterOfferStatus,
            purchaseMethod: this.state.filterPurchaseMethod,
            startDate: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
            endDate: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
            additionalData: (this.state.filterOfferStatus?.toLowerCase() === 'open' && this.state.filterCityGroupCode) ? "order-policy-stock-payment" : null
        }).then(async value => {
            if (this.state.filterOfferStatus?.toLowerCase() === 'open' && this.state.dataConfig?.event_status) {
                await this.sortOpenOffer(value.data.data);
            } else {
                await this.promisedSetState({
                    dataOffer: value.data.data,
                    processingFetchTableData: false,
                });
            }

        }).catch(async reason => {
            await this.promisedSetState({
                dataOffer: [],
                processingFetchTableData: false,
            });
            message.error('Data Tidak Ditemukan');
        });
    }

    onFieldChange = <T extends keyof Pick<any, "filterStartDate" | "filterEndDate" | "filterOfferStatus" | "chosenOfferYear" | "chosenCloseUnitDealerCode" | "chosenCloseUnitYear" | "chosenCloseUnitSearchType" | "chosenCloseUnitVehicleNumber" | "filterPurchaseMethod" | "dealershipPickUp">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "filterStartDate":
                currentState.filterStartDate = value;
                break;
            case "filterEndDate":
                currentState.filterEndDate = value;
                break;
            case "filterOfferStatus":
                currentState.filterOfferStatus = value;
                break;
            case "filterPurchaseMethod":
                currentState.filterPurchaseMethod = value;
                break;
            case "chosenOfferYear":
                currentState.chosenOfferYear = value;
                break;
            case "chosenCloseUnitDealerCode":
                currentState.chosenCloseUnitDealerCode = value;
                break;
            case "chosenCloseUnitYear":
                currentState.chosenCloseUnitYear = value;
                break;
            case "chosenCloseUnitSearchType":
                currentState.chosenCloseUnitSearchType = value;
                break;
            case "chosenCloseUnitVehicleNumber":
                currentState.chosenCloseUnitVehicleNumber = value;
                break;
            case "dealershipPickUp":
                currentState.dealershipPickUp = value;
                break;
        }
        this.setState({
            ...currentState,
        });
    }

    onCityGroupChange = (data: any) => {
        this.setState({
            filterCityGroupCode: data.value,
            filterCityGroupName: data.children,
            filterCityGroupStockCode: data.value,
            dataOffer: [],
        });
    }

    onCityGroupStockChange = (data: any) => {
        this.setState({
            filterCityGroupStockCode: data.value,
            dataOffer: [],
        });
    }

    // Create Order
    closeModalCreateOrder = () => {
        this.setState({
            createOrderOfferModal: false,
            createOrderOfferCode: ""
        });
    }

    createOrder = async (data: any, indexRow: number) => {
        const dev = true;
        if (dev) {
            Modal.error({
                title: 'error',
                content: 'Silakan Gunakan Closing Cari Unit',
            });
            return;
        }

        if (this.state?.dataConfig?.event_status) {
            if (!this.state?.dataConfig?.running_event) {
                Modal.error({
                    title: 'error',
                    content: 'Closing tidak dalam waktu event',
                });
                return;
            }

            if (indexRow !== 0) {
                Modal.error({
                    title: 'error',
                    content: 'Closing harus dimulai dari data paling atas',
                });
                return;
            }
        }

        // sementara dimatikan
        if (checkIdeal && (data?.purchase_method === "NOTcash" || data?.purchase_method === "NOTcredit")) {
            await this.promisedSetState({
                fetchIdealProcess: true,
            });

            const checkPhoneNumber = [];
            checkPhoneNumber.push(data?.owner_phone_number);
            if (data?.order_maker_phone_number && (data?.order_maker_phone_number !== data?.owner_phone_number)) {
                checkPhoneNumber.push(data?.order_maker_phone_number);
            }
            if (data?.owner_alternative_phone_number && (data?.owner_alternative_phone_number !== data?.owner_phone_number) && (data?.owner_alternative_phone_number !== data?.order_maker_phone_number)) {
                checkPhoneNumber.push(data?.owner_alternative_phone_number);
            }

            await idealChatServices.getMessageOrderConfirm({
                phoneNumber: checkPhoneNumber,
            }).then(async value => {
                if (value.data?.success?.meta?.verified) {
                    await this.promisedSetState({
                        fetchIdealProcess: false,
                        createOrderOfferModal: true,
                        chosenOfferYear: new Date().getFullYear(),
                        createOrderOfferCode: data.transaction_code,
                        chosenOfferData: data,
                    });
                } else {
                    await this.promisedSetState({
                        fetchIdealProcess: false,
                    });
                    Modal.error({
                        title: 'error',
                        content: 'Order tidak dapat diproses karena tidak ada konfirmasi dari chat Amarta Ideal',
                    });
                    return;
                }
            }).catch(async e => {
                await this.promisedSetState({
                    fetchIdealProcess: false,
                });
                Modal.error({
                    title: 'error',
                    content: 'Order tidak dapat diproses karena tidak ada konfirmasi dari chat Amarta Ideal',
                });
                return;
            });
        } else {
            await this.promisedSetState({
                createOrderOfferModal: true,
                chosenOfferYear: new Date().getFullYear(),
                createOrderOfferCode: data.transaction_code,
                chosenOfferData: data,
            });
        }
    }

    // choose unit closing
    createClosingUnitOrder = async (data: any, indexRow: number) => {

        if (this.state?.dataConfig?.event_status) {
            if (!this.state?.dataConfig?.running_event) {
                Modal.error({
                    title: 'error',
                    content: 'Closing tidak dalam waktu event',
                });
                return;
            }

            if (indexRow !== 0) {
                Modal.error({
                    title: 'error',
                    content: 'Closing harus dimulai dari data paling atas',
                });
                return;
            }
        }

        if (checkIdeal && (data?.purchase_method === "NOTcash" || data?.purchase_method === "NOTcredit")) {
            await this.promisedSetState({
                fetchIdealProcess: true,
            });

            const checkPhoneNumber = [];
            checkPhoneNumber.push(data?.owner_phone_number);
            if (data?.order_maker_phone_number && (data?.order_maker_phone_number !== data?.owner_phone_number)) {
                checkPhoneNumber.push(data?.order_maker_phone_number);
            }
            if (data?.owner_alternative_phone_number && (data?.owner_alternative_phone_number !== data?.owner_phone_number) && (data?.owner_alternative_phone_number !== data?.order_maker_phone_number)) {
                checkPhoneNumber.push(data?.owner_alternative_phone_number);
            }

            await idealChatServices.getMessageOrderConfirm({
                phoneNumber: checkPhoneNumber,
            }).then(async value => {
                if (value.data?.success?.meta?.verified) {
                    await this.promisedSetState({
                        fetchIdealProcess: false,
                        chosenCloseUnitOfferCode: data.transaction_code,
                        chosenCloseUnitStockCode: "",
                        chosenCloseUnitOfferData: data,
                        chosenCloseUnitModal: true,
                        chosenCloseUnitDealerCode: this.state.dealerCode,
                        chosenCloseUnitStockData: [],
                        chosenCloseUnitSelectedRowsKey: [],
                        chosenCloseUnitSelectedRowsData: [],
                        shipmentCostFetch: true,
                        shipmentCostShow: false,
                        shipmentCostData: {success: false},
                        dealershipPickUp: false,
                        fetchCatalogueProcess: false,
                        otrCatalogueDifferent: false,
                        otrCatalogue: 0,
                        otrCatalogueShow: false,
                    });
                } else {
                    await this.promisedSetState({
                        fetchIdealProcess: false,
                    });
                    Modal.error({
                        title: 'error',
                        content: 'Order tidak dapat diproses karena tidak ada konfirmasi dari chat Amarta Ideal',
                    });
                    return;
                }
            }).catch(async e => {
                await this.promisedSetState({
                    fetchIdealProcess: false,
                });
                Modal.error({
                    title: 'error',
                    content: 'Order tidak dapat diproses karena tidak ada konfirmasi dari chat Amarta Ideal',
                });
                return;
            });
        } else {
            await this.promisedSetState({
                fetchIdealProcess: false,
                chosenCloseUnitOfferCode: data.transaction_code,
                chosenCloseUnitStockCode: "",
                chosenCloseUnitOfferData: data,
                chosenCloseUnitModal: true,
                chosenCloseUnitDealerCode: this.state.dealerCode,
                chosenCloseUnitStockData: [],
                chosenCloseUnitSelectedRowsKey: [],
                chosenCloseUnitSelectedRowsData: [],
                shipmentCostFetch: true,
                shipmentCostShow: false,
                shipmentCostData: {success: false},
                dealershipPickUp: false,
                fetchCatalogueProcess: false,
                otrCatalogueDifferent: false,
                otrCatalogue: 0,
                otrCatalogueShow: false,
            });
        }
    }

    triggerCreateOrder = async () => {
        await this.promisedSetState({
            createOrderOfferProcessing: true,
        });

        const input = {
            company: "amarta",
            dealer_code: this.state.dealerCode,
            offer_code: this.state.createOrderOfferCode,
            vehicle_year: this.state.chosenOfferYear,
            admin_id: this.user,
            admin_name: this.user,
        }

        try {
            await offerApiServices.setToken(this.token);
            await offerApiServices.createOrder(
                input
            ).then(successData => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'Offer berhasil dibuat order, dengan kode order: ' + successData.data.data.order_code
                });
                this.closeModalCreateOrder();
                this.fetchOffer();
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            await this.promisedSetState({
                createOrderOfferProcessing: false,
            });
        }
    }
    // End Of Create Order

    closeModalCloseUnit = () => {
        this.setState({
            chosenCloseUnitModal: false,
            chosenCloseUnitOfferCode: "",
            chosenCloseUnitYear: new Date().getFullYear(),
            chosenCloseUnitDealerCode: this.state.dealerCode,
            chosenCloseUnitVehicle: {},
            chosenCloseUnitStockData: [],
            chosenCloseUnitSelectedRowsKey: [],
            chosenCloseUnitSelectedRowsData: [],
            chosenCloseUnitSearchType: true,
            chosenCloseUnitVehicleNumber: "",
            chosenCloseUnitProcessing: false,
        });
    }

    triggerCreateCloseUnitOrder = async () => {
        if (!this.state.chosenCloseUnitSelectedRowsData[0]?.stock_unit_code) {
            Modal.error({title: 'Warning', content: 'Silakan lengkapi Stock'});
            return;
        }
        if (!this.state.chosenCloseUnitYear) {
            Modal.error({title: 'Warning', content: 'Silakan lengkapi Tahun'});
            return;
        }
        if (!this.state.chosenCloseUnitDealerCode) {
            Modal.error({title: 'Warning', content: 'Silakan lengkapi Dealer'});
            return;
        }

        await this.promisedSetState({
            chosenCloseUnitProcessing: true,
        });

        const input = {
            company: "amarta",
            dealer_code: this.state.chosenCloseUnitDealerCode,
            offer_code: this.state.chosenCloseUnitOfferCode,
            vehicle_year: this.state.chosenCloseUnitYear,
            admin_id: this.user,
            admin_name: this.user,
            stock_unit_code: this.state.chosenCloseUnitSelectedRowsData[0]?.stock_unit_code,
            vehicle_engine_number: this.state.chosenCloseUnitSelectedRowsData[0]?.vehicle_engine_number,
            shipment_cost_data: this.state?.shipmentCostData,
            dealer_data: this.state.dealerCityGroupData[this.state.chosenCloseUnitDealerCode],
            take_in_dealer_data: this.state?.dealershipPickUp,
            otr_catalogue_data: this.state?.otrCatalogue
        }
        try {
            await offerApiServices.setToken(this.token);
            await offerApiServices.createOrder(
                input
            ).then(successData => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'Offer berhasil dibuat order, dengan kode order: ' + successData.data.data.order_code
                });
                this.closeModalCloseUnit();
                this.fetchOffer();
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            await this.promisedSetState({
                chosenCloseUnitProcessing: false,
            });
        }
    }

    fetchShippingCostData = () => {
        this.setState({
            shipmentCostFetch: true,
            shipmentCostShow: true,
            shipmentCostData: {success: false},
        });

        shippingCostService.getData({
            dealerCode: this.state.chosenCloseUnitDealerCode,
            cityCode: this.state.chosenCloseUnitOfferData?.address_owner?.city_code,
        }).then((dataCostShippment) => {
            this.setState({
                shipmentCostFetch: false,
                shipmentCostShow: true,
                shipmentCostData: {
                    success: true,
                    bpdeab: dataCostShippment?.data?.data?.bpdeab,
                    bpdead: dataCostShippment?.data?.data?.bpdead,
                    bpkon: dataCostShippment?.data?.data?.bpkon,
                    bureau_fee: dataCostShippment?.data?.data?.bureau_fee,
                    pdi: dataCostShippment?.data?.data?.pdi,
                    pelwil: dataCostShippment?.data?.data?.pelwil,
                    tol: dataCostShippment?.data?.data?.tol,
                }
            });
        }).catch(async (e) => {
            this.setState({
                shipmentCostFetch: false,
                shipmentCostShow: true,
                shipmentCostData: {success: false},
            });
        })
    }

    fetchStockUnitColor = async () => {
        this.fetchCatalogueVariant();
        this.fetchShippingCostData();

        let paramSearch = {};
        if (!this.state.chosenCloseUnitDealerCode) {
            Modal.error({title: 'Warning', content: 'Silakan pilih dealer'});
            return;
        }
        if (this.state.chosenCloseUnitSearchType) {
            paramSearch = {
                dealerCode: this.state.chosenCloseUnitDealerCode,
                liteRespone: true,
                vehicleYear: this.state.chosenCloseUnitYear,
                vehicleVariantCode: this.state.chosenCloseUnitOfferData.variant_code,
                vehicleColorCode: this.state.chosenCloseUnitOfferData.color_code,
                statusStock: "ACTIVE"
            }
        } else {
            if (!this.state.chosenCloseUnitVehicleNumber) {
                Modal.error({title: 'Warning', content: 'Silakan masukan nomor mesin'});
                return;
            }

            paramSearch = {
                dealerCode: this.state.chosenCloseUnitDealerCode,
                vehicleEngineNumber: this.state.chosenCloseUnitVehicleNumber?.trim(),
                vehicleVariantCode: this.state.chosenCloseUnitOfferData.variant_code,
                vehicleColorCode: this.state.chosenCloseUnitOfferData.color_code,
                statusStock: "ACTIVE"
            }
        }

        await this.promisedSetState({
            chosenCloseUnitFetching: true,
        });

        await stockApiService.getStock(paramSearch).then(async value => {
            this.setState({
                chosenCloseUnitStockData: value.data.data,
                chosenCloseUnitFetching: false,
            })
        }).catch(async reason => {
            this.setState({
                chosenCloseUnitStockData: [],
                chosenCloseUnitFetching: false,
            });
            message.error('Data Tidak Ditemukan');
        });
    }
    // end of choose unit closing

    fetchDealerData = async () => {
        try {
            await dealerApiService.getDealer({}).then(async response => {
                const tempData: any = {};
                for (const item of response?.data?.data) {
                    tempData[item?.dealer_code] = item;
                }
                await this.promisedSetState({
                    dealerCityGroupData: tempData
                });
            });
        } catch (e) {
            console.log(e);
        }
    }

    async componentDidMount() {
        await this.fetchDealerData();
        await this.fetchConfig();
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        const rowSelection = {
            chosenCloseUnitSelectedRowsKey: this.state.chosenCloseUnitSelectedRowsKey,
            chosenCloseUnitSelectedRowsData: this.state.chosenCloseUnitSelectedRowsData,
            onChange: async (chosenCloseUnitSelectedRowsKey: any, chosenCloseUnitSelectedRowsData: any) => {
                await this.promisedSetState({
                    chosenCloseUnitSelectedRowsKey: [...chosenCloseUnitSelectedRowsKey],
                    chosenCloseUnitSelectedRowsData: [...chosenCloseUnitSelectedRowsData],
                });
            },
        };

        const currentYear: number = new Date().getFullYear();
        const years: number[] = Array.from({length: 6}, (_, index) => currentYear - index);

        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Offer`} breadcrumbMenu={`Force AutoClosing`} defaultSelectedKeys={['m-force-autoclosing']} defaultOpenKeys={['sm-offer']}>
                    <div style={this.state.processingFetchConfig ? {} : {display: 'none'}} className={`spinCenter`}>
                        <Spin size="large"/>
                    </div>

                    <div style={!this.state.processingFetchConfig ? {padding: 20} : {display: 'none'}}>
                        <div style={this.state?.dataConfig?.auto_closing_status ? {} : {display: 'none'}}>
                            <Form.Item className={'padTop-20'} style={(this.state?.dataConfig?.event_status && !this.state?.dataConfig?.running_event) ? {} : {display: 'none'}}>
                                Proses Closing tidak tersedia dalam waktu ini
                            </Form.Item>

                            <div className={'padTop-20'} style={(this.state?.dataConfig?.event_status && this.state?.dataConfig?.running_event) ? {} : {display: 'none'}}>
                                <Button loading={this.state.processingFetchTableData} onClick={this.closingFulfillment} type="primary" danger={true} icon={<FlagOutlined/>}> Auto Closing & Selesai</Button>
                            </div>
                        </div>
                        <div style={!this.state?.dataConfig?.auto_closing_status ? {} : {display: 'none'}}>
                            <Form layout={`inline`}>
                                <Form.Item className={'padTop-10'} style={{width: 150}}>
                                    <i className={`small-text-grey`}>Area</i>
                                    <Tooltip title="Untuk memunculkan informasi ketersediaan kendaraan, silakan pilih area dan area stock" color={'cyan'}>
                                        <WarningOutlined style={{fontSize: "80%", marginLeft: 5, color: "#f4364c", cursor: "help"}}/>
                                    </Tooltip>
                                    <AreaGroupCitySelect companyCode={"AMARTA"} onCityGroupChangeProps={this.onCityGroupChange} dealerCode={this.state.dealerCode} value={this.state.filterCityGroupCode}/>
                                </Form.Item>
                                <Form.Item className={'padTop-10'} style={{width: 150}}>
                                    <i className={`small-text-grey`}>Area Stock</i>
                                    <AreaGroupCitySelect companyCode={"AMARTA"} onCityGroupChangeProps={this.onCityGroupStockChange} dealerCode={this.state.dealerCode} value={this.state.filterCityGroupStockCode}/>
                                </Form.Item>
                                <Form.Item className={'padTop-10'} style={{width: 100}}>
                                    <i className={`small-text-grey`}>Status</i>
                                    <Select
                                        showSearch
                                        placeholder="Pilih Status"
                                        optionFilterProp="children"
                                        onChange={value => this.onFieldChange("filterOfferStatus", value)}
                                        value={this.state.filterOfferStatus}
                                    >
                                        <Select.Option key={`open`} value={`open`}>{`OPEN`}</Select.Option>
                                        <Select.Option key={`cancel`} value={`cancel`}>{`CANCEL`}</Select.Option>
                                        <Select.Option key={`order`} value={`order`}>{`ORDER`}</Select.Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item className={'padTop-10'} style={{minWidth: 140}}>
                                    <i className={`small-text-grey`}>Metode</i>
                                    <Select
                                        showSearch
                                        placeholder="Pilih Metide"
                                        optionFilterProp="children"
                                        onChange={value => this.onFieldChange("filterPurchaseMethod", value)}
                                        value={this.state.filterPurchaseMethod}
                                    >
                                        <Select.Option key={`all`} value={``}>{`Semua Metode`}</Select.Option>
                                        <Select.Option key={`cash`} value={`cash`}>{`Tunai`}</Select.Option>
                                        <Select.Option key={`credit`} value={`credit`}>{`Kredit`}</Select.Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item className={'padTop-10'} label="">
                                    <i className={`small-text-grey`}>Tgl Awal</i><br/>
                                    <DatePicker defaultValue={moment(this.state.filterStartDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterStartDate", event)} format={'YYYY-MM-DD'}/>
                                </Form.Item>
                                <Form.Item className={'padTop-10'} label="">
                                    <i className={`small-text-grey`}>Tgl Akhir</i><br/>
                                    <DatePicker defaultValue={moment(this.state.filterEndDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterEndDate", event)} format={'YYYY-MM-DD'}/>
                                </Form.Item>

                                <Form.Item className={'padTop-20'} style={!this.state?.dataConfig?.event_status ? {} : {display: 'none'}}>
                                    <Button loading={this.state.processingFetchTableData} onClick={this.fetchOffer} type="primary" icon={<SearchOutlined/>}>Cari Data</Button>
                                </Form.Item>

                                <Form.Item className={'padTop-20'} style={(this.state?.dataConfig?.event_status && this.state?.dataConfig?.running_event) ? {} : {display: 'none'}}>
                                    <Button loading={this.state.processingFetchTableData} onClick={this.fetchOffer} type="primary" icon={<SearchOutlined/>}> Go</Button>
                                </Form.Item>

                                <Form.Item className={'padTop-20'} style={(this.state?.dataConfig?.event_status && !this.state?.dataConfig?.running_event) ? {} : {display: 'none'}}>
                                    Proses Closing tidak tersedia dalam waktu ini
                                </Form.Item>

                                <div className={'padTop-20'} style={(this.state?.dataConfig?.event_status && this.state?.dataConfig?.running_event) ? {} : {display: 'none'}}>
                                    <Button loading={this.state.processingFetchTableData} onClick={this.closingFulfillment} type="primary" danger={true} icon={<FlagOutlined/>}> Selesai</Button>
                                </div>

                            </Form>
                            <br/>
                            <Table
                                rowKey={'transaction_code'}
                                size={'small'}
                                scroll={{x: 'calc(500px + 50%)'}}
                                loading={this.state.processingFetchTableData}
                                columns={this.tableColumn}
                                dataSource={this.state.dataOffer}
                                pagination={{pageSize: this.state.pageSize}}
                                onChange={this.onChangeTable}
                            />
                        </div>
                    </div>

                    <Modal
                        open={this.state.showModalDetailStock}
                        title="Detail Offer"
                        onOk={this.closeModalDetailStock}
                        onCancel={this.closeModalDetailStock}
                        width={'80%'}
                        cancelText={'Tutup'} okText={false}
                        footer={[
                            <Button key="1" type="primary" onClick={this.closeModalDetailStock}>
                                Tutup
                            </Button>,
                        ]}
                    >
                        <DetailOffer companyCode={"AMARTA"} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                    </Modal>

                    <Modal
                        open={this.state.createOrderOfferModal}
                        title="Konfirmasi Pembuatan Order"
                        onOk={this.closeModalCreateOrder}
                        onCancel={this.closeModalCreateOrder}
                        cancelText={'Tutup'} okText={false}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button icon={<SaveOutlined/>} type={"primary"} loading={this.state.createOrderOfferProcessing} key="1" onClick={this.triggerCreateOrder}>
                                Jadikan Order
                            </Button>,
                            <Button loading={this.state.createOrderOfferProcessing} key="2" onClick={this.closeModalCreateOrder}>
                                Close
                            </Button>,
                        ]}
                    >
                        <div>
                            <Row>
                                <Col span={6} style={{color: "gray"}}>Kode Offer:</Col>
                                <Col span={18}>{this.state.createOrderOfferCode}</Col>
                            </Row>
                            <Row>
                                <Col span={6} style={{color: "gray"}}>Area:</Col>
                                <Col span={16}>{this.state.chosenOfferData?.area?.toUpperCase()}</Col>
                            </Row>
                            <Row>
                                <Col span={6} style={{color: "gray"}}>Nama Pemesan:</Col>
                                <Col span={18}>{this.state.chosenOfferData.order_maker_full_name}</Col>
                            </Row>
                            <Row>
                                <Col span={6} style={{color: "gray"}}>Nama Pemilik:</Col>
                                <Col span={18}>{this.state.chosenOfferData.owner_full_name}</Col>
                            </Row>
                            <Row>
                                <Col span={6} style={{color: "gray"}}>Nama Variant:</Col>
                                <Col span={18}>{this.state.chosenOfferData.variant_name}</Col>
                            </Row>
                            <Row>
                                <Col span={6} style={{color: "gray"}}>Warna Variant:</Col>
                                <Col span={18}>({this.state.chosenOfferData.color_code}) {this.state.chosenOfferData.color_name}</Col>
                            </Row>
                            <Row style={{paddingTop: 10}}>
                                <Col span={6} style={{color: "gray", paddingTop: 7}}>Tahun Variant:</Col>
                                <Col span={18}>
                                    <Select
                                        showSearch
                                        placeholder="Pilih Tahun"
                                        optionFilterProp="children"
                                        onChange={value => this.onFieldChange("chosenOfferYear", value?.toString())}
                                        value={this.state.chosenOfferYear}
                                    >
                                        {years.map((year) => (
                                            <Select.Option key={year} value={year}>
                                                {year}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Col>
                            </Row>
                        </div>
                    </Modal>

                    <Modal
                        open={this.state.chosenCloseUnitModal}
                        title="Konfirmasi Pembuatan Order"
                        onCancel={this.closeModalCloseUnit}
                        cancelText={'Tutup'} okText={false}
                        maskClosable={false}
                        closable={false}
                        width={'85%'}
                        footer={[
                            <Button disabled={(this.state.shipmentCostFetch || this.state.fetchCatalogueProcess)} icon={<SaveOutlined/>} type={"primary"} loading={this.state.chosenCloseUnitProcessing} key="1" onClick={this.triggerCreateCloseUnitOrder}>
                                Jadikan Order
                            </Button>,
                            <Button loading={this.state.chosenCloseUnitProcessing} key="2" onClick={this.closeModalCloseUnit}>
                                Close
                            </Button>,
                        ]}
                    >
                        <div style={{float: "right"}}>
                            <Switch checked={this.state.chosenCloseUnitSearchType} onChange={value => this.onFieldChange("chosenCloseUnitSearchType", value)} checkedChildren=" Pencarian Unit Dealer " unCheckedChildren=" Pencarian Nomor Mesin "/>
                        </div>
                        <div>
                            <Form layout={`inline`} style={{marginTop: 15}}>
                                <Form.Item style={{width: 300}}>
                                    <span style={{color: 'grey'}}>Dealer:</span>
                                    <Select
                                        showSearch
                                        placeholder="Pilih Dealer"
                                        optionFilterProp="children"
                                        onChange={value => this.onFieldChange("chosenCloseUnitDealerCode", value)}
                                        value={this.state.chosenCloseUnitDealerCode}
                                    >
                                        {this.state.dealerOption.map((item: any) => (
                                            <Select.Option key={item.value} value={item.value}>{item.name}</Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item style={this.state.chosenCloseUnitSearchType ? {width: 180} : {display: 'none'}}>
                                    <span style={{color: 'grey'}}>Tahun Kendaraan:</span>
                                    <Select
                                        showSearch
                                        placeholder="Pilih Tahun"
                                        optionFilterProp="children"
                                        onChange={value => this.onFieldChange("chosenCloseUnitYear", value)}
                                        value={this.state.chosenCloseUnitYear}
                                    >
                                        {years.map((year) => (
                                            <Select.Option key={year} value={year}>
                                                {year}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item style={!this.state.chosenCloseUnitSearchType ? {} : {display: 'none'}}>
                                    <span style={{color: 'grey'}}>Nomor Mesin:</span>
                                    <Input value={this.state.chosenCloseUnitVehicleNumber} onChange={event => this.onFieldChange("chosenCloseUnitVehicleNumber", event.target.value)} placeholder="Nomor Mesin"/>
                                </Form.Item>
                                <Form.Item style={{paddingTop: 22}}>
                                    <Button onClick={this.fetchStockUnitColor} loading={this.state.chosenCloseUnitFetching} type="primary" icon={<SearchOutlined/>}> Cari Unit </Button>
                                </Form.Item>
                            </Form>

                            <Divider style={{paddingBottom: 3, marginBottom: 3}}/>

                            <div style={this.state?.shipmentCostShow ? {} : {display: 'none'}}>
                                <Row style={this.state?.shipmentCostFetch ? {} : {display: 'none'}}>
                                    <Col xs={24} xl={24} className={`pad-10`} style={{paddingTop: 10}}>
                                        <Spin/> <code>Loading Fetch Data Shipping Cost...</code>
                                    </Col>
                                    <Divider style={{paddingTop: 3, marginTop: 3}}/>
                                </Row>

                                <Row style={(!this.state?.shipmentCostFetch && !this.state?.shipmentCostData?.success) ? {} : {display: 'none'}}>
                                    <Col xs={24} xl={24} className={`pad-10`} style={{paddingTop: 0}}>
                                        <code>Data Master Biaya Tujuan Tidak Ditemukan</code>
                                    </Col>
                                    <Divider style={{paddingTop: 3, marginTop: 3}}/>
                                </Row>
                                <Row style={(!this.state?.shipmentCostFetch && this.state?.shipmentCostData?.success) ? {} : {display: 'none'}}>
                                    <Col xs={8} xl={3} className={`pad-10`} style={{paddingTop: 0}}>
                                        <i className={`small-text-grey`}>pelwil</i><br/>
                                        {currencyFormat(this.state?.shipmentCostData?.pelwil ?? 0)}
                                    </Col>
                                    <Col xs={8} xl={3} className={`pad-10`} style={{paddingTop: 0}}>
                                        <i className={`small-text-grey`}>pdi</i><br/>
                                        {currencyFormat(this.state?.shipmentCostData?.pdi ?? 0)}
                                    </Col>
                                    <Col xs={8} xl={3} className={`pad-10`} style={{paddingTop: 0}}>
                                        <i className={`small-text-grey`}>bpkon</i><br/>
                                        {currencyFormat(this.state?.shipmentCostData?.bpkon ?? 0)}
                                    </Col>
                                    <Col xs={8} xl={3} className={`pad-10`} style={{paddingTop: 0}}>
                                        <i className={`small-text-grey`}>bpdead</i><br/>
                                        {currencyFormat(this.state?.shipmentCostData?.bpdead ?? 0)}
                                    </Col>
                                    <Col xs={8} xl={3} className={`pad-10`} style={{paddingTop: 0}}>
                                        <i className={`small-text-grey`}>bpdeab</i><br/>
                                        {currencyFormat(this.state?.shipmentCostData?.bpdeab ?? 0)}
                                    </Col>
                                    <Col xs={8} xl={3} className={`pad-10`} style={{paddingTop: 0}}>
                                        <i className={`small-text-grey`}>biro jasa</i><br/>
                                        {currencyFormat(this.state?.shipmentCostData?.bureau_fee ?? 0)}
                                    </Col>
                                    <Col xs={8} xl={3} className={`pad-10`} style={{paddingTop: 0}}>
                                        <i className={`small-text-grey`}>tol</i><br/>
                                        {currencyFormat(this.state?.shipmentCostData?.tol ?? 0)}
                                    </Col>
                                    <Divider style={{paddingTop: 3, marginTop: 3}}/>
                                </Row>
                            </div>

                            <Row>
                                <Col xs={24} xl={17} className={`pad-10`}>
                                    <span style={!this.state.otrCatalogueShow ? {display: 'none'} : {}}>
                                        <span style={{fontSize: "85%", color: "grey"}}>OTR Offer:</span>
                                        <span style={{fontSize: "85%", paddingLeft: 7}}>{currencyFormat(this.state.chosenCloseUnitOfferData.otr_price)}</span>
                                        <span style={{fontSize: "85%", color: "grey", paddingLeft: 10}}>OTR Catalog:</span>
                                        <span style={this.state.fetchCatalogueProcess ? {display: 'none'} : {fontSize: "85%", paddingLeft: 7}}>{currencyFormat(this.state.otrCatalogue)}</span>
                                        <span style={!this.state.fetchCatalogueProcess ? {display: 'none'} : {fontSize: "85%", paddingLeft: 7}}><Spin/> Loading...</span>
                                        <span style={!this.state.otrCatalogueDifferent ? {display: 'none'} : {fontSize: "85%", paddingLeft: 7}}>
                                            <Tooltip title="Nilai OTR Offer berbeda dengan OTR katalog" color={'red'}>
                                                <WarningOutlined style={{color: "red", fontSize: "120%"}}/>
                                            </Tooltip>
                                        </span>
                                    </span>
                                    <br/><br/>

                                    <Table
                                        rowSelection={{
                                            type: 'radio',
                                            ...rowSelection,
                                        }}
                                        loading={this.state.chosenCloseUnitFetching}
                                        scroll={{x: 'calc(500px + 50%)'}}
                                        rowKey={'stock_unit_code'}
                                        columns={this.tableStockUnitColumn}
                                        dataSource={this.state.chosenCloseUnitStockData}
                                        size={"small"}
                                    />
                                </Col>

                                <Col xs={24} xl={7} className={`pad-10`}>
                                    <Row>
                                        <Checkbox checked={this.state.dealershipPickUp} onChange={e => this.onFieldChange("dealershipPickUp", e.target.checked)}> <span className={`divider-stock-purchase`}> Pengambilan di dealer </span> </Checkbox>
                                    </Row>

                                    <Row style={{paddingTop: 10}}>
                                        <Col span={8} style={{color: "gray"}}>Offer:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitOfferCode}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Area:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitOfferData?.area?.toUpperCase()}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Pemesan:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitOfferData.order_maker_full_name}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Pemilik:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitOfferData.owner_full_name}</Col>
                                    </Row>

                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Kota Pemilik:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitOfferData?.address_owner?.city_name ?? ""} ({this.state.chosenCloseUnitOfferData?.address_owner?.city_code ?? ""})</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Kec Pemilik:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitOfferData?.address_owner?.district_name ?? ""} ({this.state.chosenCloseUnitOfferData?.address_owner?.district_code ?? ""})</Col>
                                    </Row>

                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>VariantCode:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitOfferData.variant_code}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Variant:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitOfferData.variant_name}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Warna:</Col>
                                        <Col span={16}>({this.state.chosenCloseUnitOfferData.color_code}) {this.state.chosenCloseUnitOfferData.color_name}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Tahun:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitYear}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Kode Agen:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitOfferData?.agent_code}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Kode Indent:</Col>
                                        <Col span={16}>{this.state.chosenCloseUnitOfferData?.indent_code}</Col>
                                    </Row>

                                    <Row className={`pt-5`} style={this.state.chosenCloseUnitOfferData?.take_vehicle_in_dealer ? {} : {display: 'none'}}>
                                        <Col xs={24} xl={24}><br/><br/>*Konsumen Memilih mengambil kendaraan di dealer <br/><br/></Col>
                                    </Row>

                                    <Divider/>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Stock:</Col>
                                        <Col span={16} style={{fontSize: '75%', color: "#096dd9"}}>{this.state.chosenCloseUnitSelectedRowsData[0]?.stock_unit_code}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Mesin:</Col>
                                        <Col span={16} style={{color: "#096dd9"}}>{this.state.chosenCloseUnitSelectedRowsData[0]?.vehicle_engine_number}</Col>
                                    </Row>
                                    <Row>
                                        <Col span={8} style={{color: "gray"}}>Dealer:</Col>
                                        <Col span={16} style={{color: "#096dd9"}}>{this.state.chosenCloseUnitSelectedRowsData[0]?.dealer_name}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Modal>

                    <Modal
                        open={this.state.detailOrderModal}
                        title="Detail Order"
                        onCancel={this.closeModalDetailOrder}
                        footer={[
                            <Button key="1" type="primary" onClick={this.closeModalDetailOrder}>Tutup</Button>,
                        ]}
                    >
                        <DetailOrder orderCode={this.state.detailOrderCode} time={Math.floor(+new Date() / 1000)}/>
                    </Modal>

                    <Modal
                        open={this.state.fetchIdealProcess}
                        closeIcon={true}
                        footer={null}
                    >
                        <div style={{textAlign: "center", padding: 20, minHeight: 100}}>
                            <Spin style={{marginTop: 20}} size={'large'} tip="Processing..."/>
                        </div>

                        <div style={{textAlign: "center", padding: 20}}>
                            Mohon menunggu beberapa saat, system sedang memverifikasi chat ideal.
                        </div>
                    </Modal>

                    <Modal
                        open={this.state.fulfillmentModal}
                        title={(this.state?.dataConfig?.auto_closing_status) ? `Konfirmasi Auto Closing & Selesai Season` : `Konfirmasi SELESAI`}
                        onCancel={this.closeFulfillmentModal}
                        cancelText={'Tutup'} okText={false}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button type={"primary"} loading={this.state.fulfillmentProcess} onClick={this.setFulfillmentClosing} key="1">
                                {(this.state?.dataConfig?.auto_closing_status) ? `AUTO CLOSING & SELESAI` : `SELESAI`}
                            </Button>,
                            <Button loading={this.state.fulfillmentProcess} key="2" onClick={this.closeFulfillmentModal}>
                                Close
                            </Button>,
                        ]}
                    >
                        Anda Yakin Akan Malakukan <b>{(this.state?.dataConfig?.auto_closing_status) ? `Auto Closing & Selesai Season` : `Selesai Pemenuhan`}</b> dengan melakukan selesai pemenuhan, anda tidak dapat melakukan closing untuk beberapa waktu kedepan ? <br/><br/>
                    </Modal>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(ForceClosing), 14));